import React, { useState, useEffect } from "react";
import axios from "axios";
import { jwtVerify, SignJWT } from 'jose';



const ItemCodePage = () => {
  const [formData, setFormData] = useState({
    itemcode: ""
  });
  const [errors, setErrors] = useState({});
  const [confirm, setConfirm] = useState({});
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  const [flow, setFlow] = useState(null);
  const [lineUserID, setLineUserID] = useState(null);
  const [refCode, setRefCode] = useState(null);
  const [otp, setOtp] = useState(null);
  const [action, setAction] = useState(null);
  const [gameid, setGameid] = useState(null);

  // Decode token and set state
  useEffect(() => {
    const decodeToken = async () => {
      const urlParams = new URLSearchParams(window.location.search);
      const token = urlParams.get("token");

      //console.log("Token:", token);

      if (token) {
        try {
          const key = new TextEncoder().encode("dbf0450af36284d45b9ebddf166f3aa278d19091f27362c542525fdac56e4b9f");
          const { payload } = await jwtVerify(token, key);

          // Set your state values here
          setFlow(payload.flow);
          setLineUserID(payload.lineUserID);
          setRefCode(payload.refCode);
          setOtp(payload.otp);
          setAction(payload.action);
          setGameid(payload.gameid);
          if (payload.prefillCode) {
            setFormData({
              itemcode: payload.prefillCode
            });
          }

        } catch (error) {
          console.error("Invalid token:", error);
          setErrors({ apiError: "ข้อมูลไม่ถูกต้องกรุณาตรวจสอบ URL" });
        }
      } else {
        setErrors({ apiError: "ข้อมูลไม่ถูกต้องกรุณาตรวจสอบ URL" });
      }
    };

    decodeToken(); // Call the async function
  }, []); // Empty dependency array ensures this runs only once

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.itemcode) newErrors.itemcode = "กรุณากรอก ไอไอเท็มโค้ด";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setConfirm({title : null, description : null})
    setSuccessMessage("");
    if (!validateForm()) return;

    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get("token");
    if (!token) return

    try {
      setLoading(true);
      const headers = {
        "Accept-Language": "th",
        "Accept": "application/json;charset=UTF-8",
        "Content-Type": "application/json;charset=UTF-8",
        "api-key": "ss3+Nn9s%!$$DJ35bXISQYC!c+^P4x3Rk*2nWB3Q%$k29yUzLAthISeXa%d2LMvG",
        "login-access-token": token,
      };
      const secret = new TextEncoder().encode("dbf0450af36284d45b9ebddf166f3aa278d19091f27362c542525fdac56e4b9f");  
      const alg = 'HS256'
      const jwt = await new SignJWT({ ...formData })
        .setProtectedHeader({ alg })
        .setIssuedAt()
        .setExpirationTime('2h')
        .sign(secret);
      const response = await axios.post(
        "https://apis.ranworld-adventures.com/v2/account/itemcode/complete",
        { token: jwt },
        { headers }
      );
      setSuccessMessage(response?.data);
      setFormData({
        itemcode: ""
      });
      setErrors({});
    } catch (error) {
      console.error("Error submitting registration:", error);
      setErrors({
        apiError: error.response?.data || "An unexpected error occurred.",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleItemCodeCheck = async (e) => {
    e.preventDefault();
    setConfirm({title : null, description : null})
    setSuccessMessage("");
    if (!validateForm()) return;

    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get("token");
    if (!token) return

    try {
      setLoading(true);
      const headers = {
        "Accept-Language": "th",
        "Accept": "application/json;charset=UTF-8",
        "Content-Type": "application/json;charset=UTF-8",
        "api-key": "ss3+Nn9s%!$$DJ35bXISQYC!c+^P4x3Rk*2nWB3Q%$k29yUzLAthISeXa%d2LMvG",
        "login-access-token": token,
      };
      const secret = new TextEncoder().encode("dbf0450af36284d45b9ebddf166f3aa278d19091f27362c542525fdac56e4b9f");  
      const alg = 'HS256'
      const jwt = await new SignJWT({ ...formData })
        .setProtectedHeader({ alg })
        .setIssuedAt()
        .setExpirationTime('2h')
        .sign(secret);
      const response = await axios.post(
        "https://apis.ranworld-adventures.com/v2/account/itemcode/check",
        { token: jwt },
        { headers }
      );
      if (response?.status == 200 && response?.data != "VIP_RANK") {
        setConfirm({
          title: "ยืนยันการแลกรางวัล",
          description: "คุณต้องการแลกรางวัลหรือไม่",
        });
      } else if (response?.status == 200 && response?.data === "VIP_RANK") {
        setConfirm({
          title: "ยืนยันการแลกรางวัลวีไอพี",
          description: "หากคุณมีอันดับไวอีพีอยู่แล้ว สถานะดังกล่าวจะถูกยกเลิก และคุณจะได้รับสถานะไวอีพีใหม่",
        });
      }
    } catch (error) {
      console.error("Error submitting registration:", error);
      setErrors({
        apiError: error.response?.data || "An unexpected error occurred.",
      });
    } finally {
      setLoading(false);
    }
  };

  const ErrorModalNew = ({ title, message, onClose }) => {
    return (
      <div className="modal-overlay">
        <div className="modal2">
          <h3>{title}</h3>
          <p>{message}</p>
          <button onClick={onClose}>ปิด</button>
        </div>
      </div>
    );
  };

  const ConfirmModalNew = ({ title, message, onOk, onClose }) => {
    return (
      <div className="modal-overlay">
        <div className="modal2">
          <h3>{title}</h3>
          <p>{message}</p>
          <div className="modal-buttons">
            <button onClick={onOk}>ยืนยัน</button>
            <button onClick={onClose}>ยกเลิก</button>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div style={{ padding: "20px", maxWidth: "400px", margin: "auto" }}>
      {/* <div style={{ textAlign: "center", marginBottom: "20px" }}>
        <img 
          src="https://thenewadventuresimages.s3.us-east-1.amazonaws.com/Add+a+heading+(5).png" 
          alt="True Money Logo" 
          style={{ maxWidth: "auto", height: "90px" }} 
        />
      </div> */}

      {errors.apiError && (
        <ErrorModalNew title="ขออภัย" message={errors.apiError} onClose={() => setErrors({ apiError : null})}/>
      )}

      {confirm.title && confirm.description && (
        <ConfirmModalNew title={confirm.title} message={confirm.description} onOk={handleSubmit} onClose={() => setConfirm({ title : null, description : null})}/>
      )}

      {successMessage && (
        <div
          style={{
            color: "green",
            marginBottom: "20px",
            padding: "10px",
            border: "1px solid green",
            borderRadius: "5px",
            backgroundColor: "#dfd",
            fontFamily: "Prompt"
          }}
        >
          {successMessage}
        </div>
      )}

      {/* Display Query Parameters */}
      <div
        style={{
          marginBottom: "20px",
          padding: "10px",
          border: "1px solid #ccc",
          borderRadius: "5px",
          backgroundColor: "#f9f9f9",
        }}
      >
        <ul style={{ listStyleType: "none", padding: 0, margin: 0 }}>
          {[
            { title: "ไอดีเกม", value: gameid },
            { title: "รหัสอ้างอิง", value: refCode },
          ].map(({ title, value }) => (
            <li
              key={title}
              style={{
                display: "flex",
                justifyContent: "space-between",
                padding: "5px 0",
              }}
            >
              <span style={{ fontSize: "14px", color: "#555", flex: 1 }}>{title}:</span>
              <span style={{ fontSize: "14px", color: "#555", flex: 1, textAlign: "right" }}>{value || "N/A"}</span>
            </li>
          ))}
        </ul>
      </div>

      <form onSubmit={handleItemCodeCheck}>
        {/* ไอเท็มโค้ด */}
        <div style={{ marginBottom: "15px" }}>
          <label>
            ITEM CODE:
            <input
              type="text"
              name="itemcode"
              placeholder="กรอก ไอเท็มโค้ด"
              value={formData.itemcode}
              onChange={handleInputChange}
              style={{
                display: "block",
                width: "100%",
                padding: "10px",
                marginTop: "5px",
                border: "1px solid #ccc",
                borderRadius: "5px",
                boxSizing: "border-box",
                fontFamily: "Prompt"
              }}
            />
            {errors.itemcode && (
              <span style={{ color: "red", fontSize: "12px" }}>
                {errors.itemcode}
              </span>
            )}
          </label>
        </div>

        {/* Submit Button */}
        <button
          type="submit"
          disabled={loading}
          style={{
            width: "100%",
            padding: "10px",
            backgroundColor: loading ? "#ccc" : "#007bff",
            color: "#fff",
            border: "none",
            borderRadius: "5px",
            fontSize: "16px",
            cursor: loading ? "not-allowed" : "pointer",
            boxSizing: "border-box",
            fontFamily: "Prompt"
          }}
        >
          {loading ? "กำลังประมวณผล..." : "ตรวจสอบ"}
        </button>
      </form>

    </div>
  );
};

export default ItemCodePage;